var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageEmptyMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M0 0h180v180H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h180v180H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.8 65.017 57.75-40.063a10 10 0 0 1 11.4 0l57.75 40.063a10 10 0 0 1 4.3 8.216V126a8 8 0 0 1-8 8H30.5a8 8 0 0 1-8-8V73.233a10 10 0 0 1 4.3-8.216z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.196 70.07 54.67 35.915a6 6 0 0 1 0 10.03l-54.67 35.914A4 4 0 0 1 22 148.586V73.414a4 4 0 0 1 6.196-3.343zM152.304 70.07l-54.67 35.915a6 6 0 0 0 0 10.03l54.67 35.914a4 4 0 0 0 6.196-3.343V73.414a4 4 0 0 0-6.196-3.343z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.965 151.668-57.181-37.991a10 10 0 0 0-11.068 0l-57.181 37.991A4 4 0 0 0 29.749 159H150.75a4 4 0 0 0 2.214-7.332zM110.854 14.097l9.046 1.595a4.8 4.8 0 0 1 3.81 5.943l-10.009 38.243a4.8 4.8 0 0 1-5.477 3.511l-5.878-1.036a4.8 4.8 0 0 1-3.894-5.56l6.842-38.802a4.8 4.8 0 0 1 5.56-3.894zm29.766 31.79 6.676 6.12a4.8 4.8 0 0 1 .022 7.056l-16.684 15.49a4.8 4.8 0 0 1-6.389.127l-3.272-2.804a4.8 4.8 0 0 1-.798-6.414l13.28-18.806a4.8 4.8 0 0 1 7.165-.77z",
    fill: "#CACACA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageEmptyMessage);
export default __webpack_public_path__ + "static/media/image_empty_message.dd3b4b1e12b51189ccba3e2bb9a1bf67.svg";
export { ForwardRef as ReactComponent };